import React from 'react';

const GallerySection = () => {
const galleryImages = [
  { thumb: '/images/fleet/2.jpeg', full: '/images/fleet/2.jpeg' },
  { thumb: '/images/fleet/3.jpeg', full: '/images/fleet/3.jpeg' },
  { thumb: '/images/fleet/4.jpeg', full: '/images/fleet/4.jpeg' },

  { thumb: '/images/fleet/5.jpeg', full: '/images/fleet/5.jpeg' },

  { thumb: '/images/fleet/6.jpeg', full: '/images/fleet/6.jpeg' },
  { thumb: '/images/fleet/7.jpeg', full: '/images/fleet/7.jpeg' },
  { thumb: '/images/fleet/8.jpeg', full: '/images/fleet/8.jpeg' },
  { thumb: '/images/fleet/9.jpeg', full: '/images/fleet/9.jpeg' },
  { thumb: '/images/fleet/10.jpeg', full: '/images/fleet/10.jpeg' },
  { thumb: '/images/fleet/11.jpeg', full: '/images/fleet/11.jpeg' },
  { thumb: '/images/fleet/12.jpeg', full: '/images/fleet/11.jpeg' },
  { thumb: '/images/fleet/13.jpeg', full: '/images/fleet/11.jpeg' },
  { thumb: '/images/fleet/audi.jpg', full: '/images/fleet/audi.jpg' },
  { thumb: '/images/fleet/aura.jpg', full: '/images/fleet/aura.jpg' },
  { thumb: '/images/fleet/bus.jpg', full: '/images/fleet/bus.jpg' },
  { thumb: '/images/fleet/dsire.jpg', full: '/images/fleet/dsire.jpg' },
  { thumb: '/images/fleet/ertiga.jpg', full: '/images/fleet/ertiga.jpg' },
  { thumb: '/images/fleet/etios.jpg', full: '/images/fleet/etios.jpg' },
  { thumb: '/images/fleet/innova.jpg', full: '/images/fleet/innova.jpg' },
  { thumb: '/images/fleet/innova-crysta.jpg', full: '/images/fleet/innova-crysta.jpg' },
  { thumb: '/images/fleet/kia.jpg', full: '/images/fleet/kia.jpg' },
  { thumb: '/images/fleet/mini-bus.jpg', full: '/images/fleet/mini-bus.jpg' },
  { thumb: '/images/fleet/tempo-trevellar.jpg', full: '/images/fleet/tempo-trevellar.jpg' },
];

  return (
<>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title">Gallery</h2>
          </div>
        </div>
      </div>
    </div>


    <section className="section gallery-section">
      <div className="container">
        <div className="row">
          {galleryImages.map((img, index) => (
            <div
              key={index}
              className="col-lg-4 col-md-6 col-sm-6 col-12"
              data-aos="fade-down"
            >
              <div className="gallery-widget borderr">
                <a href={img.full} data-fancybox="gallery2">
                  <img className="img-fluid" src={img.thumb} alt={`Gallery ${index + 1}`} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
</>
  );
};

export default GallerySection;